import { LegalDocumentPage } from "@/components/pages/legal-document-page";

export default function PrivacyPolicyPage() {
  return (
    <LegalDocumentPage
      title="Privacy Policy"
      htmlUrl="/privacy-policy.html"
      defaultReturnPath="/"
    />
  );
}

